<template>
	<div>
		<div class="table-responsive">
			<div style="text-align: center; width: 100%" v-if = "salesList.length!=0"></div>
			<table class="table">
				<thead>
					<tr>
						<th>&nbsp;</th>
						<th>Asin</th>
						<th>Product Title</th>
						<th>Shipped COGS</th>
						<th>Shipped COGS - % of total</th>
						<th>Shipped COGS - last year</th>
						<th>Shipped Units</th>
						<th>Shipped Units - % of total</th>
						<th>Shipped Units - last year</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in salesList" :key="item.asin + '_' + item.id">
						<td></td>
						<td>{{item.asin}}</td>
						<td>{{item.producttitle}}</td>
						<td>{{item.shippedcogs}}</td>
						<td>{{item.shippedcogs_percoftotal}}</td>
						<td>{{item.shippedcogs_lastyear}}</td>
						<td>{{item.shippedunits}}</td>
						<td>{{item.shippedunits_percoftotal}}</td>
						<td>{{item.shippedunits_lastyear}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>

	var moment = require("moment");
	export default {
		name: "SalesListGrid.vue",
		data() {
			return {

			};
		},
		props: {
		},
		mounted() {
			//console.log(this.notificationList);
		},
		computed: {
			salesList: {
				set(val) {
					this.$store.state.sales.salesList = val
				},
				get() {
					return this.$store.state.sales.salesList
				}
			},
		},
		components: {
		},
		methods: {
		},

	};
</script>

<style lang="scss">
</style>
